import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { getMember } from '@vista-digital/occ-domain';
import { observer } from 'mobx-react';
import { Button } from '../../../subcomponents/button/button';
import { Field } from '../../../subcomponents/form/field/field/field';
import { getFieldId } from '../../../subcomponents/form/field/utils/field-attribute-utils';
import { Input } from '../../../subcomponents/form/input/input/input';
import { InputType } from '../../../subcomponents/form/input/input/types/type';
import { withComponentWrapper } from '../../../utils/with-component-wrapper';
import { UpdateMemberCredentialPromptFormFieldName as FieldName } from './types/field-name';
import { defaultUpdateMemberCredentialPromptFormPropsProvider, updateMemberCredentialPromptFormPropsValidator } from './types/props';
const b = bemClassBuilder('v-update-member-credential-prompt-form');
const UpdateMemberCredentialPromptForm = observer(props => {
    const { fieldToUpdate, displayText, events, config } = props;
    return (_jsxs("div", { className: b.block(), children: [_jsx(Field, { id: getFieldId(b, fieldToUpdate), label: displayText.fieldLabel, className: b.element('field'), children: _jsx(Input, { value: getOriginalValue(props) || '', type: getInputType(fieldToUpdate), disabled: true }) }), _jsx(Button, { label: displayText.actionButtonLabel, className: b.element('action-button'), onClick: events.onActionButtonClicked, size: config.actionButton.size })] }));
});
UpdateMemberCredentialPromptForm.displayName = 'UpdateMemberCredentialPromptForm';
/**
 * The **Update Member Credential Prompt Form** component renders a form that prompts updating a member's email,
 * password, or username.
 */
export const UpdateMemberCredentialPromptFormComponent = withComponentWrapper(UpdateMemberCredentialPromptForm, defaultUpdateMemberCredentialPromptFormPropsProvider, updateMemberCredentialPromptFormPropsValidator);
const getInputType = (field) => {
    switch (field) {
        case FieldName.Password:
            return InputType.Password;
        case FieldName.Email:
            return InputType.Email;
        case FieldName.Username:
        default:
            return InputType.Text;
    }
};
const getOriginalValue = (props) => {
    const member = getMember();
    switch (props.fieldToUpdate) {
        case FieldName.Password:
            return new Array(props.config.maskedPasswordLength).join('.');
        case FieldName.Email:
            return member === null || member === void 0 ? void 0 : member.credentials.email;
        case FieldName.Username:
            return member === null || member === void 0 ? void 0 : member.credentials.username;
        default:
            throw new Error(`Cannot render UpdateMemberCredentialPromptFormField. Unsupported field name: '${props.fieldToUpdate}'.`);
    }
};
//# sourceMappingURL=update-member-credential-prompt-form.js.map